import React, {useRef, useState, useEffect} from 'react';
import {ReactFlowProvider, MarkerType} from '@xyflow/react';
import $ from 'jquery';
import '@xyflow/react/dist/style.css';
import {useDispatch, useSelector} from 'react-redux';
import MotifIcon from '@ey/motif-react-wrapper/Icon';
import {IconoirPlusCircle} from '@ey-xd/motif-icon';
import styled from 'styled-components';
import _ from 'lodash';
import {useDocumentId, useEngagementId} from '../../../util/customHooks';
import FlowchartStep from './CustomFlowComponents/FlowchartStepNode';
import CustomEdge from './CustomFlowComponents/CustomEdge';
import FlowchartColumn from './CustomFlowComponents/FlowchartColumnNode';
import mockFlow from '../../Common/scotPlacemat/flow';
import ReactFlowComponent from '../../Common/scotPlacemat/ReactFlowComponent';
import {getFlow, setUp, getChartData} from '../../Common/scotPlacemat/flowUtils';
import Button from '../../Common/BaseComponentWrappers/MotifButton';
import {labels} from '../../../util/utils';
import {getFlowChart, setIsFlowchartStepEditModalOpen} from '../../../actions/FlowChart/flowchartactions';
import AddEditStep from './AddEditStep';

export default function FlowChartPlacement(props) {
	const dispatch = useDispatch();
	const engagementId = useEngagementId();
	const documentId = useDocumentId();
	const flowChart = useSelector((state) => state.flowChart);
	const flowchartStep = useSelector((state) => state.flowchartStep);
	const isEditModelOpen = useSelector((state) => state.isFlowChartStepEditModelOpen);
	const [showAddStepModal, setShowAddStepModal] = useState(false);
	const [showEditStepModal, setShowEditStepModal] = useState(false);

	console.log('flowChart ===>>', flowChart);

	const nodeTypes = {
		FlowchartStep: FlowchartStep,
		FlowchartColumn: FlowchartColumn
	};
	const edgeTypes = {
		'custom-edge': CustomEdge
	};

	useEffect(() => {
		setShowEditStepModal(isEditModelOpen);
		if (!isEditModelOpen && flowchartStep.id !== undefined) {
			dispatch(
				getFlowChart(
					engagementId,
					{
						documentId: documentId,
						formBodyId: props.bodyId,
						includeRelatedSteps: true,
						includeStepRelatedObjects: true
					},
					[]
				)
			);
		}
		props.bodyContent.name = 'Document';
	}, [isEditModelOpen]);

	const instanceRef = useRef(null);
	$('.MainContainerWrapper').removeClass('left-margin');
	const [chart, setChart] = useState(null);

	useEffect(() => {
		if (_.isEmpty(flowChart)) {
			props.setIsLoading(true);
			getFlowChartDetails()
				.then(() => {
					props.setIsLoading(false);
				})
				.catch(() => {
					props.setIsLoading(false);
				});
		}
	}, []);

	useEffect(() => {
		if (engagementId) {
			setChart(getChartData(flowChart));
		} else {
			let flow = setUp(mockFlow);
			setChart(flow);
		}
	}, [flowChart]);

	const markerEnd = {
		type: MarkerType.Arrow,
		width: 15,
		height: 15,
		color: '#c3c3cb'
	};

	const getFlowChartDetails = () => {
		return dispatch(
			getFlowChart(
				engagementId,
				{
					documentId: documentId,
					formBodyId: props.bodyId,
					includeRelatedSteps: true,
					includeStepRelatedObjects: true
				},
				[]
			)
		);
	};

	const onDetachClick = (id) => {
		const latestChart = getFlow(instanceRef, true);
		const detachedNodes = latestChart.nodes.map((node) => {
			if (node.id === id && node.extent) {
				delete node.extent;
			}
			return node;
		});
		setChart({...chart, nodes: detachedNodes});
	};

	const onDeleteClick = (id) => {
		const newNodes = chart.nodes.filter((node) => node.id !== id);
		setChart({...chart, nodes: newNodes});
	};

	function onAddStepClick() {
		props.bodyContent.evidenceDocumentReferenceCount = 0;
		setShowAddStepModal(!showAddStepModal);
	}

	const onCloseHandler = () => {
		setShowAddStepModal(false);
		dispatch(setIsFlowchartStepEditModalOpen(false));
	};

	return (
		<>
			<ReactFlowProvider>
				<Wrapper className="labelbtn">
					<section className="title">{props.scotName}</section>
					<ButtonDiv className="PanelStyles">
						<Button size="medium" onClick={onAddStepClick}>
							<MotifIcon src={IconoirPlusCircle} />
							<span>{labels.newstep}</span>
						</Button>
					</ButtonDiv>
				</Wrapper>
				{chart && chart.nodes.length > 0 ? (
					<ReactFlowComponent
						getFlowChartDetails={getFlowChartDetails}
						engagementId={engagementId}
						documentId={documentId}
						flowchartId={flowChart?.data ? flowChart?.data[0]?.id : {}}
						formBodyId={flowChart?.data[0]?.formBodyId}
						onDeleteClick={onDeleteClick}
						onDetachClick={onDetachClick}
						nodeTypes={nodeTypes}
						edgeTypes={edgeTypes}
						edgeComponent={CustomEdge}
						data={chart}
						initRef={instanceRef}
						columnWidth={780}
						offsetX={10}
						markerEnd={markerEnd}
					/>
				) : null}
			</ReactFlowProvider>

			{showAddStepModal && (
				<AddEditStep
					onCloseHandler={onCloseHandler}
					flowchartId={flowChart?.data[0]?.id}
					formBodyId={props.bodyId}
					showAddEditStepModal={showAddStepModal}
					formHeaderId={props.headerId}
					formBodyContent={props.bodyContent}
					props={props}
					isSnapshotView={props.isSnapshotView}
					isAresView={props.isAresView}
					showGuidance={props.showGuidance}
					dontShowEngagementSelector={props.dontShowEngagementSelector}
				/>
			)}
			{showEditStepModal && (
				<AddEditStep
					onCloseHandler={onCloseHandler}
					flowchartId={flowChart?.data[0]?.id}
					formBodyId={flowChart?.data[0]?.formBodyId}
					showAddEditStepModal={showEditStepModal}
					flowChartStepId={flowchartStep.id}
					stepName={flowchartStep.stepName}
					stepDescription={flowchartStep.stepDescription}
					props={props}
					formHeaderId={props.headerId}
					formBodyContent={props.bodyContent}
					isSnapshotView={props.isSnapshotView}
					isAresView={props.isAresView}
					showGuidance={props.showGuidance}
					dontShowEngagementSelector={props.dontShowEngagementSelector}
				/>
			)}
		</>
	);
}

const ButtonDiv = styled.div`
	button {
		margin: var(--px-5);
	}
`;

const Wrapper = styled.div`
	display: flex;
	margin-bottom: var(--px-48);

	.title {
		font-size: var(--px-16);
		color: var(--neutrals-900);
		margin-right: var(--px-50);
	}

	.title,
	.PanelStyles {
		display: inline-flex;
	}

	.PanelStyles {
		margin-left: auto;
		button .motif-icon {
			svg {
				color: var(--neutrals-00white);
			}
		}
	}
`;
